import config from '../../config';

/** API_BASE_URL already includes `/api` (e.g. https://host/api). */
export function rbacUrl(path) {
  const base = (config.API_BASE_URL || '').replace(/\/$/, '');
  const segment = path.startsWith('/') ? path.slice(1) : path;
  return `${base}/${segment}`;
}
